import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LeadModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function LeadModal({
  isOpen,
  onClose
}: LeadModalProps) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      onClose();
    }, 3000);
  };
  return <AnimatePresence data-id="element-204">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-205">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-206" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-md glass-panel rounded-2xl p-8 overflow-hidden" data-id="element-207">
            <button onClick={onClose} className="absolute top-4 right-4 text-textSecondary hover:text-white transition-colors" data-id="element-208">
              <X size={20} data-id="element-209" />
            </button>

            {isSubmitted ? <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="text-center py-8" data-id="element-210">
                <div className="w-16 h-16 bg-accent/20 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-211">
                  <div className="w-8 h-8 bg-accent rounded-full animate-pulse" data-id="element-212" />
                </div>
                <h3 className="text-2xl font-semibold mb-2" data-id="element-213">
                  Request Received
                </h3>
                <p className="text-textSecondary" data-id="element-214">
                  Our strategy team will be in touch shortly to discuss your
                  custom dashboard.
                </p>
              </motion.div> : <>
                <div className="mb-8" data-id="element-215">
                  <h3 className="text-2xl font-semibold mb-2" data-id="element-216">
                    Build My Dashboard
                  </h3>
                  <p className="text-textSecondary text-sm" data-id="element-217">
                    Stop guessing. Start seeing. Leave your details below and
                    we'll schedule a strategy call.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4" data-id="element-218">
                  <div data-id="element-219">
                    <label className="block text-sm font-medium text-textSecondary mb-1" data-id="element-220">
                      Full Name
                    </label>
                    <input required type="text" className="w-full bg-secondary border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-accent/50 focus:ring-1 focus:ring-accent/50 transition-all" placeholder="Jane Doe" data-id="element-221" />
                  </div>
                  <div data-id="element-222">
                    <label className="block text-sm font-medium text-textSecondary mb-1" data-id="element-223">
                      Work Email
                    </label>
                    <input required type="email" className="w-full bg-secondary border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-accent/50 focus:ring-1 focus:ring-accent/50 transition-all" placeholder="jane@company.com" data-id="element-224" />
                  </div>
                  <div data-id="element-225">
                    <label className="block text-sm font-medium text-textSecondary mb-1" data-id="element-226">
                      Company Name
                    </label>
                    <input required type="text" className="w-full bg-secondary border border-white/10 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-accent/50 focus:ring-1 focus:ring-accent/50 transition-all" placeholder="Acme Corp" data-id="element-227" />
                  </div>
                  <button type="submit" className="w-full bg-white text-black font-medium rounded-lg px-4 py-3 mt-4 hover:bg-white/90 transition-colors" data-id="element-228">
                    Request Access
                  </button>
                </form>
              </>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}